var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddRainbow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.33301C7.63148 1.33301 7.33301 1.63148 7.33301 1.99967V7.33301H1.99967C1.63148 7.33301 1.33301 7.63148 1.33301 7.99967C1.33301 8.36786 1.63148 8.66634 1.99967 8.66634H7.33301V13.9997C7.33301 14.3679 7.63148 14.6663 7.99967 14.6663C8.36786 14.6663 8.66634 14.3679 8.66634 13.9997V8.66634H13.9997C14.3679 8.66634 14.6663 8.36786 14.6663 7.99967C14.6663 7.63148 14.3679 7.33301 13.9997 7.33301H8.66634V1.99967C8.66634 1.63148 8.36786 1.33301 7.99967 1.33301Z",
    fill: "url(#paint0_linear_12544_37787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12544_37787",
    x1: 1.33301,
    y1: 7.99969,
    x2: 14.6663,
    y2: 7.99969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6AE6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddRainbow);
export default __webpack_public_path__ + "static/media/icon-add-rainbow.07f4d15d6ffdb252f9dc6607677eee09.svg";
export { ForwardRef as ReactComponent };